import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useI18n } from '../content/i18n';
import './IPadSection.css';

gsap.registerPlugin(ScrollTrigger);

const IPadSection = () => {
  const { t } = useI18n();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const ipadRef = useRef(null);
  
  const [isLandscape, setIsLandscape] = useState(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 타이틀이 떨어지는 애니메이션
      gsap.fromTo(
        titleRef.current,
        { 
          y: -100,
          opacity: 0,
          scale: 1.2
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'bounce.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
            end: 'top 50%',
            toggleActions: 'play none none none',
          },
        }
      );

      // 서브타이틀 애니메이션
      gsap.fromTo(
        subtitleRef.current,
        { 
          opacity: 0,
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 65%',
            end: 'top 45%',
            scrub: 1,
          },
        }
      );

      // 아이패드 페이드인
      gsap.fromTo(
        ipadRef.current,
        { 
          opacity: 0,
          scale: 0.8
        },
        {
          opacity: 1,
          scale: 1,
          duration: 1,
          scrollTrigger: {
            trigger: ipadRef.current,
            start: 'top 80%',
            end: 'top 50%',
            scrub: 1,
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    // 아이패드 회전 애니메이션 무한 루프
    const animateRotation = () => {
      // 세로 -> 가로
      setTimeout(() => {
        setIsLandscape(true);
      }, 3000);

      // 가로 -> 세로
      setTimeout(() => {
        setIsLandscape(false);
      }, 6000);
    };

    // 초기 실행
    animateRotation();

    // 반복
    const interval = setInterval(() => {
      animateRotation();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ipad-section" ref={sectionRef}>
      <div className="ipad-content container container--wide">
        <h2 className="ipad-title" ref={titleRef}>
          {t.ipad.title}
        </h2>
        <p className="ipad-subtitle" ref={subtitleRef}>
          {t.ipad.subtitle}
        </p>
        
        <div className="ipad-container" ref={ipadRef}>
          <div className={`ipad-device ${isLandscape ? 'landscape' : 'portrait'}`}>
            <div className="ipad-screen">
              <img 
                src={isLandscape ? '/resource/pad_landscape.PNG' : '/resource/pad_portrait.PNG'}
                alt={isLandscape ? t.ipad.altLandscape : t.ipad.altPortrait}
                className="ipad-screenshot"
              />
            </div>
            <div className="ipad-camera"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IPadSection;
